import _reduce from 'lodash/reduce';
var SubReducerBase = /** @class */ (function () {
    function SubReducerBase(config) {
        this.config = config;
    }
    SubReducerBase.prototype.isChatroomUnread = function (state, chatroomId) {
        return (state.chatroomIds || {})[chatroomId];
    };
    SubReducerBase.prototype.parseUnreadChatroomIdsArray = function (unreadChatroomIds) {
        var chatroomIds = _reduce(unreadChatroomIds, function (result, chatroomId) {
            result[chatroomId] = true;
            return result;
        }, {});
        return {
            chatroomIds: chatroomIds,
            chatroomsCount: unreadChatroomIds.length,
        };
    };
    SubReducerBase.prototype.reduceToTrackingOverflowState = function () {
        return {
            chatroomIds: undefined,
            chatroomsCount: undefined,
            resyncCountdown: this.config.maxTrackableUnreads - this.config.maxUnreadsCount,
        };
    };
    SubReducerBase.prototype.isInTrackingOverflowState = function (state) {
        return state.resyncCountdown !== undefined;
    };
    return SubReducerBase;
}());
export { SubReducerBase };
